import { render } from "./Gallographic.vue?vue&type=template&id=89f68220&scoped=true"
import script from "./Gallographic.vue?vue&type=script&lang=js"
export * from "./Gallographic.vue?vue&type=script&lang=js"

import "./Gallographic.vue?vue&type=style&index=0&id=89f68220&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f68220"]])

export default __exports__